// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/banner-hero-image-full/banner-hero-image-full.component.scss
// module id = 444
// module chunks = 0